export const QCIdentifier = "QC".toLowerCase();
